import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import uiActions from "../../../../../../../redux/ui/action";
import authActions from "../../../../../../../redux/auth/action";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  url_169,
  url_302,
  url_303,
  url_8,
} from "../../../../../../../custom_utilities/api_services";
import {
  clearAwaitPaymentFromUrl,
  clearPendingHandbookOrderId,
  extractMid,
  extractOrderId,
  extractTxnAmount,
  extractTxnToken,
  getPendingHandbookOrderId,
  hasPaytmCallbackResourceHit,
  invokePaytmJsCheckout,
  isPaymentCompleted,
  isPaymentFailed,
  PAYTM_POLL_INTERVAL_MS,
  PAYTM_STATUS_MAX_ATTEMPTS,
  shouldFinalizeFromStatusPoll,
  shouldFinalizePayment,
  resolveGatewayPaymentMode,
  resolvePaymentFailureReason,
  wasReferredFromPaytmCallback,
} from "../../../../../../../custom_utilities/paytm_payment/paytmHandbookHelpers";
import PaytmPaymentStatus from "../../../../../../../custom_utilities/paytm_payment/PaytmPaymentStatus";
import {
  clearWebEngagePaymentContext,
  getWebEngagePaymentContext,
  trackWebEngagePaymentCompleted,
  trackWebEngagePaymentFailed,
} from "../../../../../../../custom_utilities/webengage/webengageService";

const PaytmHandbookResponse = (props) => {
  const {
    tokenType,
    token,
    orderId,
    handBookOrderId,
    paytmDetails,
    transactionData,
    startLoading,
    finishLoading,
    setUser,
  } = props;

  const [handbookResponse, setHandbookResponse] = useState({});
  const [showCheckout, setShowCheckout] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [isPolling, setIsPolling] = useState(false);
  const [isCheckingStatus, setIsCheckingStatus] = useState(false);
  const [isReceiptLoading, setIsReceiptLoading] = useState(false);
  const [isPendingVerification, setIsPendingVerification] = useState(false);
  const history = useHistory();
  const pollCleanupRef = useRef(null);
  const checkoutSubmittedRef = useRef(false);
  const paymentSettledRef = useRef(false);
  const gatewayReturnedRef = useRef(false);
  const statusCheckStartedRef = useRef(false);
  const pollingStartedRef = useRef(false);
  const showResultRef = useRef(false);
  const failedPaymentTrackedRef = useRef(new Set());
  const completedPaymentTrackedRef = useRef(new Set());

  const getOrderIdFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    return (
      params.get("order_id") ||
      params.get("ORDERID") ||
      params.get("orderId") ||
      getPendingHandbookOrderId() ||
      ""
    );
  };

  const getResolvedOrderId = () =>
    orderId || handBookOrderId || getOrderIdFromUrl();

  const isAwaitingPayment = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("await_payment") === "1";
  };

  const isPaymentReturn = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get("payment_return") === "1";
  };

  const getPaymentEventAttributes = (responseData = {}, extraAttributes = {}) => {
    const savedContext = getWebEngagePaymentContext();
    const priceInfo = transactionData?.price_info || {};
    const currentOrderId = getResolvedOrderId() || savedContext.order_id;
    const programName =
      transactionData?.product_name ||
      transactionData?.name ||
      transactionData?.title ||
      savedContext.program_name ||
      savedContext.product_name;
    const totalAmount =
      priceInfo?.total_price ??
      savedContext.final_price ??
      savedContext.total_amount ??
      savedContext.amount ??
      savedContext.program_price;
    const programPrice =
      priceInfo?.price ??
      savedContext.program_price ??
      transactionData?.price ??
      totalAmount;
    const specialPrice =
      priceInfo?.special_price ??
      priceInfo?.discounted_price ??
      transactionData?.special_price ??
      transactionData?.discounted_price ??
      savedContext.special_price ??
      totalAmount;
    const discountAmount =
      priceInfo?.discount ??
      priceInfo?.coupon_discount ??
      transactionData?.discount ??
      savedContext.discount_amount;
    const transactionId =
      responseData?.txnId ||
      responseData?.TXNID ||
      responseData?.transaction_id ||
      savedContext.transaction_id ||
      currentOrderId;

    return {
      order_id: currentOrderId,
      product_id:
        transactionData?.product_id ||
        transactionData?.p_id ||
        savedContext.product_id,
      product_name: programName,
      program_name: programName,
      program_details:
        transactionData?.description ||
        transactionData?.short_description ||
        savedContext.program_details,
      program_price: programPrice,
      final_price: totalAmount,
      special_price: specialPrice,
      coupon_code:
        transactionData?.coupon_code ||
        priceInfo?.coupon_code ||
        savedContext.coupon_code,
      coupon_mode:
        transactionData?.coupon_mode ||
        transactionData?.coupon_type ||
        priceInfo?.coupon_mode ||
        priceInfo?.coupon_type ||
        savedContext.coupon_mode,
      discount_amount: discountAmount,
      transaction_id: transactionId,
      total_amount: totalAmount,
      source: savedContext.source || "handbook",
      amount: totalAmount,
      ...extraAttributes,
      payment_mode:
        resolveGatewayPaymentMode(responseData) ||
        resolveGatewayPaymentMode(extraAttributes) ||
        resolveGatewayPaymentMode(transactionData) ||
        resolveGatewayPaymentMode(priceInfo) ||
        savedContext.payment_mode,
    };
  };

  const recordWebEngagePaymentSuccess = (responseData = {}) => {
    const attributes = getPaymentEventAttributes(responseData);
    const deduplicationKey = attributes.order_id || "handbook-payment";

    if (completedPaymentTrackedRef.current.has(deduplicationKey)) return;
    completedPaymentTrackedRef.current.add(deduplicationKey);

    trackWebEngagePaymentCompleted(attributes);
    clearWebEngagePaymentContext();
  };

  const recordWebEngagePaymentFailure = (responseData = {}) => {
    const attributes = getPaymentEventAttributes(responseData, {
      reason: resolvePaymentFailureReason(responseData),
    });
    const deduplicationKey = attributes.order_id || "handbook-payment";

    if (failedPaymentTrackedRef.current.has(deduplicationKey)) return;
    failedPaymentTrackedRef.current.add(deduplicationKey);

    trackWebEngagePaymentFailed(attributes);
    clearWebEngagePaymentContext();
  };

  const fetchTransactionStatus = async (currentOrderId) => {
    const headers = {
      Authorization: `${tokenType} ${token}`,
    };

    const response = await axios.get(
      `${url_302}?order_id=${encodeURIComponent(currentOrderId)}`,
      { headers }
    );

    return response.data;
  };

  const showFailureResult = async (seedResponse, { refresh = true } = {}) => {
    if (paymentSettledRef.current) return;
    paymentSettledRef.current = true;
    stopPolling();
    setIsPendingVerification(false);
    setIsCheckingStatus(false);
    setShowCheckout(false);
    setShowResult(true);

    const currentOrderId = getResolvedOrderId();
    let failureData =
      seedResponse && typeof seedResponse === "object"
        ? seedResponse
        : { paymentStatus: "Failed" };

    if (refresh && currentOrderId) {
      try {
        const responseData = await fetchTransactionStatus(currentOrderId);
        if (responseData.status === 200) {
          failureData = responseData;
        }
      } catch (error) {
        console.log("Error fetching handbook failure transaction status:", error);
      }
    }

    setHandbookResponse(failureData);
    clearAwaitPaymentFromUrl(history);
    clearPendingHandbookOrderId();
    recordWebEngagePaymentFailure(failureData);
  };

  const showPendingVerificationResult = async (
    lastResponse = {},
    { refresh = true } = {}
  ) => {
    if (paymentSettledRef.current) return;
    paymentSettledRef.current = true;
    stopPolling();
    setShowCheckout(false);
    setIsCheckingStatus(false);
    setIsPolling(false);
    setShowResult(true);
    setIsPendingVerification(true);

    const currentOrderId = getResolvedOrderId();
    let pendingData = {
      paymentStatus: "Pending",
      receipt: {
        heading: "Pending Verification",
        sub_message:
          "Your payment is still being verified. This can take a few minutes.",
      },
      ...lastResponse,
    };

    if (refresh && currentOrderId) {
      try {
        const responseData = await fetchTransactionStatus(currentOrderId);
        if (responseData.status === 200) {
          pendingData = responseData;
        }
      } catch (error) {
        console.log("Error fetching handbook pending transaction status:", error);
      }
    }

    setHandbookResponse(pendingData);
    clearAwaitPaymentFromUrl(history);
  };

  const handlePaymentResult = async (
    responseData,
    { refresh = true } = {}
  ) => {
    if (paymentSettledRef.current) return;
    paymentSettledRef.current = true;
    stopPolling();
    setIsPendingVerification(false);
    setIsCheckingStatus(false);
    setShowCheckout(false);
    setShowResult(true);

    let finalData = responseData || {};
    const currentOrderId = getResolvedOrderId();

    if (refresh && currentOrderId) {
      try {
        const freshData = await fetchTransactionStatus(currentOrderId);
        if (freshData.status === 200) {
          finalData = freshData;
        }
      } catch (error) {
        console.log("Error refreshing handbook transaction status:", error);
      }
    }

    setHandbookResponse(finalData);
    clearAwaitPaymentFromUrl(history);
    clearPendingHandbookOrderId();

    if (isPaymentCompleted(finalData)) {
      await saveUserTransactions();
      recordWebEngagePaymentSuccess(finalData);
    } else {
      recordWebEngagePaymentFailure(finalData);
    }
  };

  const updateUser = async () => {
    startLoading();
    try {
      const response = await axios.get(url_8);
      if (response.data.status === 200) {
        setUser(response.data.data);
        finishLoading();
        return 1;
      }
      finishLoading();
      return 0;
    } catch (error) {
      console.log(error);
      finishLoading();
      return 0;
    }
  };

  const saveUserTransactions = async () => {
    const priceInfo = transactionData?.price_info;
    if (!priceInfo) return;

    const { price, discount, shipping, total_price } = priceInfo;
    const dataDetails = {
      price,
      discount,
      shipping_charge: shipping,
      total_price,
      coupon_discount: 0,
    };

    startLoading();
    try {
      const response = await axios.post(url_169, dataDetails);
      if (response.data.status === 200) {
        finishLoading();
        await updateUser();
      } else {
        finishLoading();
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const triggerPdfDownload = (blob, fileName) => {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(objectUrl);
  };

  const downloadReceipt = async () => {
    const currentOrderId = getResolvedOrderId();
    if (!currentOrderId) {
      alert("Order id not found.");
      return;
    }

    setIsReceiptLoading(true);
    try {
      const response = await axios.get(url_303, {
        params: { order_id: currentOrderId },
        headers: {
          Authorization: `${tokenType} ${token}`,
        },
        responseType: "blob",
      });

      const contentType = response.headers?.["content-type"] || "";

      if (contentType.includes("application/pdf")) {
        triggerPdfDownload(
          new Blob([response.data], { type: "application/pdf" }),
          `receipt-${currentOrderId}.pdf`
        );
        return;
      }

      const responseText = await response.data.text();
      let payload = {};
      try {
        payload = JSON.parse(responseText);
      } catch (parseError) {
        console.log("Error parsing receipt response:", parseError);
      }

      const msg = payload?.message;
      alert(
        typeof msg === "string" && msg
          ? msg
          : "Could not download receipt."
      );
    } catch (error) {
      console.log("Error downloading receipt:", error);
      const errorPayload = error?.response?.data;
      let message = "";

      if (errorPayload instanceof Blob) {
        try {
          const parsed = JSON.parse(await errorPayload.text());
          message = parsed?.message || "";
        } catch (parseError) {
          console.log("Error parsing receipt error response:", parseError);
        }
      } else {
        message = errorPayload?.message || error?.message || "";
      }

      alert(message || "Could not download receipt. Please try again.");
    } finally {
      setIsReceiptLoading(false);
    }
  };

  const getPaytmHandbookStatus = async () => {
    const currentOrderId = getResolvedOrderId();
    if (!currentOrderId) return;

    try {
      const responseData = await fetchTransactionStatus(currentOrderId);

      if (
        responseData.status === 200 &&
        shouldFinalizePayment(responseData)
      ) {
        await handlePaymentResult(responseData);
      } else {
        await showFailureResult(responseData);
      }
    } catch (err) {
      await showFailureResult();
    }
  };

  const stopPolling = () => {
    if (pollCleanupRef.current) {
      pollCleanupRef.current();
      pollCleanupRef.current = null;
    }
    pollingStartedRef.current = false;
  };

  const startPostGatewayStatusPolling = (currentOrderId) => {
    if (pollingStartedRef.current || paymentSettledRef.current) return;
    pollingStartedRef.current = true;

    let settled = false;
    let attempts = 0;
    let lastResponse = null;

    const cleanup = () => {
      clearInterval(pollTimer);
      setIsPolling(false);
      pollCleanupRef.current = null;
      pollingStartedRef.current = false;
    };

    const settleTerminal = async (responseData) => {
      if (settled || paymentSettledRef.current) return;
      settled = true;
      cleanup();
      setIsCheckingStatus(false);
      await handlePaymentResult(responseData, { refresh: false });
    };

    // After max polls still not Completed/Failed (typical user cancel) → Unsuccessful.
    const settleCancelledAsUnsuccessful = async (responseData) => {
      if (settled || paymentSettledRef.current) return;
      settled = true;
      cleanup();
      setIsCheckingStatus(false);
      await showFailureResult(
        {
          ...(responseData || {}),
          paymentStatus: "Failed",
        },
        { refresh: false }
      );
    };

    const pollStatus = async () => {
      if (settled || paymentSettledRef.current) return true;
      if (attempts >= PAYTM_STATUS_MAX_ATTEMPTS) return true;

      attempts += 1;

      try {
        const responseData = await fetchTransactionStatus(currentOrderId);
        if (responseData.status !== 200) {
          if (attempts >= PAYTM_STATUS_MAX_ATTEMPTS) {
            await settleCancelledAsUnsuccessful(lastResponse || {});
            return true;
          }
          return false;
        }

        lastResponse = responseData;

        if (shouldFinalizeFromStatusPoll(responseData)) {
          await settleTerminal(responseData);
          return true;
        }

        if (attempts >= PAYTM_STATUS_MAX_ATTEMPTS) {
          await settleCancelledAsUnsuccessful(responseData);
          return true;
        }
      } catch (error) {
        console.log("Error polling handbook transaction status:", error);
        if (attempts >= PAYTM_STATUS_MAX_ATTEMPTS) {
          await settleCancelledAsUnsuccessful(lastResponse || {});
          return true;
        }
      }
      return false;
    };

    setIsPolling(true);
    pollStatus();

    const pollTimer = setInterval(async () => {
      if (settled || paymentSettledRef.current) return;
      await pollStatus();
    }, PAYTM_POLL_INTERVAL_MS);

    pollCleanupRef.current = cleanup;
  };

  const beginStatusCheckAfterGatewayActivity = (reason = "unknown") => {
    if (paymentSettledRef.current || statusCheckStartedRef.current) {
      console.log("[Paytm][handbook][cancel] status check skipped", {
        reason,
        paymentSettled: paymentSettledRef.current,
        statusCheckStarted: statusCheckStartedRef.current,
      });
      return;
    }

    console.log("[Paytm][handbook][cancel] beginStatusCheckAfterGatewayActivity", {
      reason,
      orderId: getResolvedOrderId(),
    });

    gatewayReturnedRef.current = true;
    statusCheckStartedRef.current = true;

    const currentOrderId = getResolvedOrderId();
    setShowCheckout(false);
    setIsCheckingStatus(true);
    setIsPolling(true);

    if (!currentOrderId) {
      console.warn("[Paytm][handbook][cancel] no order id");
      setIsCheckingStatus(false);
      showFailureResult();
      return;
    }

    startPostGatewayStatusPolling(currentOrderId);
  };

  const handleCheckStatusAgain = async () => {
    const currentOrderId = getResolvedOrderId();
    if (!currentOrderId) return;

    setIsPolling(true);
    try {
      const responseData = await fetchTransactionStatus(currentOrderId);

      if (responseData.status !== 200) return;

      if (
        isPaymentCompleted(responseData) ||
        shouldFinalizePayment(responseData) ||
        isPaymentFailed(responseData)
      ) {
        paymentSettledRef.current = false;
        setIsPendingVerification(false);
        await handlePaymentResult(responseData);
        return;
      }

      setHandbookResponse(responseData);
      setIsPendingVerification(true);
      setShowResult(true);
    } catch (error) {
      console.log("Error checking handbook payment status again:", error);
    } finally {
      setIsPolling(false);
    }
  };

  useEffect(() => {
    const currentOrderId = getResolvedOrderId();
    console.log("[Paytm][handbook][checkout] gateway page mount", {
      currentOrderId,
      awaitPayment: isAwaitingPayment(),
      paymentReturn: isPaymentReturn(),
      hasPaytmDetails: Boolean(Object.keys(paytmDetails || {}).length),
      referrer: document.referrer,
    });
    if (!currentOrderId) return;

    if (
      isPaymentReturn() ||
      wasReferredFromPaytmCallback() ||
      hasPaytmCallbackResourceHit()
    ) {
      beginStatusCheckAfterGatewayActivity("mount_payment_return");
    } else if (isAwaitingPayment() && Object.keys(paytmDetails || {}).length) {
      console.log("[Paytm][handbook][checkout] opening CheckoutJS (redirect:false)");
      setShowCheckout(true);
    } else {
      getPaytmHandbookStatus();
    }

    return () => {
      stopPolling();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!showCheckout || checkoutSubmittedRef.current) return;
    if (!Object.keys(paytmDetails || {}).length) return undefined;

    let cancelled = false;

    const openCheckout = async () => {
      const mid = extractMid(paytmDetails);
      const checkoutOrderId =
        extractOrderId(paytmDetails) || getResolvedOrderId();
      const txnToken = extractTxnToken(paytmDetails);
      const amount =
        extractTxnAmount(paytmDetails) ||
        transactionData?.price_info?.total_price ||
        transactionData?.price ||
        transactionData?.amount ||
        "";

      console.log("[Paytm][handbook][checkout] invoke fields", {
        mid,
        checkoutOrderId,
        hasTxnToken: Boolean(txnToken),
        amount,
      });

      try {
        await invokePaytmJsCheckout({
          mid,
          orderId: checkoutOrderId,
          txnToken,
          amount,
          rootId: "",
          onPaymentActivity: (type, payload) => {
            if (cancelled) return;
            console.log(
              "[Paytm][handbook][cancel] CheckoutJS activity payload",
              payload
            );
            beginStatusCheckAfterGatewayActivity(`checkoutjs:${type}`);
          },
        });
        if (!cancelled) checkoutSubmittedRef.current = true;
      } catch (error) {
        console.error("[Paytm][handbook][checkout] CheckoutJS open failed", error);
        if (!cancelled) {
          checkoutSubmittedRef.current = true;
          showFailureResult();
        }
      }
    };

    const timer = setTimeout(openCheckout, 50);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCheckout, paytmDetails]);

  const renderStatusCheckingLoader = () => (
    <div
      style={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: "#f1f5f9",
        gap: "16px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          border: "3px solid #cbd5e1",
          borderTopColor: "#e11d48",
          borderRadius: "50%",
          animation: "paytm-status-spin 0.8s linear infinite",
        }}
      />
      <div
        style={{
          fontFamily: "Poppins, sans-serif",
          fontSize: "16px",
          fontWeight: 500,
          color: "#263238",
        }}
      >
        Checking payment status...
      </div>
      <style>
        {`@keyframes paytm-status-spin { to { transform: rotate(360deg); } }`}
      </style>
    </div>
  );

  useEffect(() => {
    showResultRef.current = Boolean(showResult);
  }, [showResult]);

  useEffect(() => {
    const onPopState = () => {
      if (!showResultRef.current) return;
      history.replace({
        pathname: "/store",
        state: { tab: "hand_books" },
      });
    };

    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToStore = () => {
    history.push({
      pathname: "/store",
      state: { tab: "hand_books" },
    });
  };

  const goToMyPackages = () => {
    history.push({
      pathname: "/user_edit_profile",
      state: { tab: "packages" },
    });
  };

  const statusTransactionData = {
    txn_amount:
      transactionData?.price_info?.total_price ??
      transactionData?.price ??
      transactionData?.amount,
    package_name:
      transactionData?.product_name ||
      transactionData?.name ||
      transactionData?.title ||
      transactionData?.package_name,
    package_duration: transactionData?.duration || transactionData?.package_duration,
    package_id:
      transactionData?.product_id ||
      transactionData?.p_id ||
      transactionData?.package_id,
    txn_date:
      transactionData?.txn_date ||
      new Date().toISOString().replace("T", " ").substring(0, 19),
  };

  const renderResult = () => (
    <PaytmPaymentStatus
      paytmResponse={handbookResponse}
      transactionData={statusTransactionData}
      onDownloadReceipt={downloadReceipt}
      isReceiptLoading={isReceiptLoading}
      isPendingVerification={isPendingVerification}
      onCheckStatusAgain={handleCheckStatusAgain}
      isCheckingStatus={isPolling}
      successPrimaryLabel="Check My packages"
      onSuccessPrimary={goToMyPackages}
      onTryAgain={goToStore}
      onReturnToStore={goToStore}
      onBack={goToStore}
      onGoToDashboard={goToStore}
    />
  );

  // Blank host: CheckoutJS (root:"") paints its own full-page overlay.
  if (showCheckout) {
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          background: "#fff",
        }}
        aria-hidden="true"
      />
    );
  }

  if (isCheckingStatus && !showResult) {
    return renderStatusCheckingLoader();
  }

  if (showResult && (Object.keys(handbookResponse).length || isPendingVerification)) {
    return renderResult();
  }

  return renderStatusCheckingLoader();
};

const mapStateToProps = (state) => ({
  orderId: state.paymentReducer.orderId,
  handBookOrderId: state.handBookPaymentData.handBookOrderId,
  userData: state.auth.user,
  token: state.auth.authToken,
  tokenType: state.auth.authType,
  paytmDetails: state.paymentReducer.paytmDetails,
  transactionData: state.handBookPaymentData.handBookTransactionDetails,
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => {
    dispatch(uiActions.startLoading());
  },
  finishLoading: () => {
    dispatch(uiActions.finishLoading());
  },
  setUser: (payload) => {
    dispatch(authActions.setUser(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PaytmHandbookResponse);
